module.exports = __webpack_public_path__ + "img/tick.2d30cdb0.png";